import translationEN from "./en.json";
import translationES from "./es.json";
import translationTE from "./te.json";
import translationHI from "./hi.json";
import translationFR from "./fr.json";
import translationDE from "./de.json";
import translationIT from "./it.json";
import translationPT from "./pt.json";
import translationZH_CN from "./zh-cn.json";
import translationZH_TW from "./zh-tw.json";
import translationJA from "./ja.json";
import translationKO from "./ko.json";
import translationAR from "./ar.json";
import translationPL from "./pl.json";
import translationNL from "./nl.json";
import translationSV from "./sv.json";
import translationNO from "./no.json";
import translationDA from "./da.json";
import translationFI from "./fi.json";
import translationHE from "./he.json";
import translationCS from "./cs.json";
import translationEL from "./el.json";
import translationHU from "./hu.json";
import translationRO from "./ro.json";
import translationSK from "./sk.json";
import translationHR from "./hr.json";
import translationET from "./et.json";
import translationLT from "./lt.json";
import translationLV from "./lv.json";
import translationSL from "./sl.json";
import translationRU from "./ru.json";

const translatedLanguages = {
  en: {
    translation: translationEN,
  },
  "en-US": {
    translation: translationEN,
  },
  te: {
    translation: translationTE,
  },
  hi: {
    translation: translationHI,
  },
  es: {
    translation: translationES,
  },
  sp: {
    translation: translationES,
  },
  fr: {
    translation: translationFR,
  },
  de: {
    translation: translationDE,
  },
  it: {
    translation: translationIT,
  },
  pt: {
    translation: translationPT,
  },
  "zh-CN": {
    translation: translationZH_CN,
  },
  "zh-TW": {
    translation: translationZH_TW,
  },
  ja: {
    translation: translationJA,
  },
  ko: {
    translation: translationKO,
  },
  ar: {
    translation: translationAR,
  },
  pl: {
    translation: translationPL,
  },
  nl: {
    translation: translationNL,
  },
  sv: {
    translation: translationSV,
  },
  no: {
    translation: translationNO,
  },
  da: {
    translation: translationDA,
  },
  fi: {
    translation: translationFI,
  },
  he: {
    translation: translationHE,
  },
  cs: {
    translation: translationCS,
  },
  el: {
    translation: translationEL,
  },
  hu: {
    translation: translationHU,
  },
  ro: {
    translation: translationRO,
  },
  sk: {
    translation: translationSK,
  },
  hr: {
    translation: translationHR,
  },
  et: {
    translation: translationET,
  },
  lt: {
    translation: translationLT,
  },
  lv: {
    translation: translationLV,
  },
  sl: {
    translation: translationSL,
  },
  ru: {
    translation: translationRU,
  },
};

export default translatedLanguages;
